import Link from "next/link";

type CtaButtonProps = {
  text: string;
  href: string;
  targetBlank?: boolean;
  arrow?: boolean;
};

export default function CtaButton({
  text,
  href,
  targetBlank = false,
  arrow = false,
}: CtaButtonProps) {
  return (
    <Link
      href={href}
      className='z-50'
      target={targetBlank ? "_blank" : undefined}
      rel={targetBlank ? "noopener noreferrer" : undefined}
    >
      <button className='bg-[#619F1C] text-white cursor-pointer font-medium px-6 py-3 rounded-full hover:bg-[#D27140] transition-colors duration-200'>
        <p
          className={`min-w-32.5${
            arrow ? " inline-flex items-center justify-center gap-2" : ""
          }`}
          style={{ textShadow: "0 0 1px rgba(0,0,0,0.35)" }}
        >
          {text}
          {arrow && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
              aria-hidden='true'
            >
              <path d='M5 12h14M13 6l6 6-6 6' />
            </svg>
          )}
        </p>
      </button>
    </Link>
  );
}
